import React from 'react';
import { Block } from '../../types';
import { DecompositionParams } from '../../services';
import { allData } from '../../../1-bibliotheque-prix/data/ServicesData';
import VentilationSourceRow from '../Ventilation/VentilationSourceRow';

interface VentilationRowPanelProps {
  block: Block;
  allBlocks: Block[];
  onBlocksChange: (blocks: Block[]) => void;
  /** Paramètres MO/appro pour permettre la décomposition sur chaque ligne ventilée. */
  decompositionParams?: DecompositionParams;
}

const VentilationRowPanel: React.FC<VentilationRowPanelProps> = ({
  block, allBlocks, onBlocksChange, decompositionParams,
}) => {
  const costLines = allBlocks.filter(b => b.parentId === block.id && b.content.isVentilationCostLine);
  return (
    <div className="border-b border-violet-100 border-l-4 border-l-violet-300 bg-violet-50/30">
      <VentilationSourceRow
        block={block}
        costLines={costLines}
        allBlocks={allBlocks}
        ouvrages={allData}
        onBlocksChange={onBlocksChange}
        decompositionParams={decompositionParams}
      />
    </div>
  );
};

export default VentilationRowPanel;
